import EntryTime from 'app/components/PositionColumns/EntryTime'
import moment from 'moment'
import React from 'react'
import { render } from 'react-dom'
import { Text, View } from 'styles/reactnative'
import CurrencyEdit from './CurrencyEdit'

export const CurrencyColumns = mutate => {
	return [
		{
			title: 'CODE',
			dataIndex: 'code',
		},
		{
			title: '통화',
			dataIndex: 'name',
			width: 300,
			render : (text, data)=>(
				<CurrencyEdit code={data?.code} type={'name'} value={text} refresh={mutate}/>
			)
		},
		{
			title: '환율',
			dataIndex: 'price',
			width: 200,
			render : (text, data)=>(
				<CurrencyEdit code={data?.code} type={'price'} value={text}  refresh={mutate}/>
			)
		},
		{
			title: '심볼',
			dataIndex: 'symbol',
			width: 300,
			render : (text, data)=>(
				<CurrencyEdit code={data?.code} type={'symbol'} value={text}  refresh={mutate}/>
			)
		},
		{
			title: '갱신일시',
			dataIndex: 'update_at',
			width: 250,
			render: (text, data) => (
				<EntryTime time={text} offset={9}/>
			),
		},
	]
}
